import { render, staticRenderFns } from "./ReprocessedTransactions.vue?vue&type=template&id=2806e7bb&scoped=true"
import script from "./ReprocessedTransactions.vue?vue&type=script&lang=js"
export * from "./ReprocessedTransactions.vue?vue&type=script&lang=js"
import style0 from "./ReprocessedTransactions.vue?vue&type=style&index=0&id=2806e7bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806e7bb",
  null
  
)

export default component.exports